module.exports = __webpack_public_path__ + "img/store-slash.c2d79fdf.svg";